export class User {
    public xbcUserId: string | undefined;
    public userName: string | undefined;
    public employeeId: string | undefined;
    public emailId: string | undefined;
}
